import { TextAreaProps } from "../../types";
import { Label, TextBox, TextAreaRoot, ErrorText } from "./InputBox.styles";

function Textarea(props: TextAreaProps) {
  const { id, labelName, placeHolderName, value, handler, error } = props;
  return (
    <TextAreaRoot>
      <Label error={Boolean(error)} htmlFor={id}>
        {labelName}
      </Label>

      <TextBox
        id={id}
        name={id}
        placeholder={placeHolderName}
        value={value}
        onChange={(e) => {
          handler(e);
        }}
        error={Boolean(error)}
      />

      {error && <ErrorText>{`* ${error}`}</ErrorText>}
    </TextAreaRoot>
  );
}

export default Textarea;
